import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[user-type-form]',
})
export class UserTypeFormDirective {
  public constructor(public container: ViewContainerRef) {}
}
